import { forwardRef, type ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface PillButtonProps {
  children: ReactNode;
  isDisabled?: boolean;
  className?: string;
  onClick?: () => void;
}

const PillButton = forwardRef<HTMLButtonElement, PillButtonProps>(
  ({ children, isDisabled = false, className, onClick }, ref) => (
    <Button
      ref={ref}
      onClick={onClick}
      className={cn(
        'px-3.5 cursor-pointer bg-secondary hover:bg-secondary border-none border-default-border rounded-full text-secondary-foreground shadow-xs',
        { 'opacity-50 pointer-events-none': isDisabled },
        className
      )}
    >
      {children}
    </Button>
  )
);

export default PillButton;
